<template lang="html">
  <si-container>
    <v-flex xs4>
      <v-card>
        <v-card-title primary-title>
          <v-spacer />
          <!-- <SiUserAvatar size="128" editable/> -->
          <div class="my-4">
            <v-avatar
              :size="130"
              color="white"
            >
              <SiImage
                :image="user.details.image"
                :save-path="`users/console/${userId}`"
                :register-paths="[`users/console/${userId}/details`]"
                :aspect-ratio="1"
                border
              />
            </v-avatar>
          </div>
          <v-spacer />
        </v-card-title>
        <v-card-title>
          <v-spacer />
          {{ `${user.details.firstName} ${user.details.lastName}` }}
          <v-spacer />
        </v-card-title>
        <v-card-text class="pt-4">
          <SiInputText
            v-model="user.details.firstName"
            label="First name"
            outlined
            @change="save"
          />
          <SiInputText
            v-model="user.details.lastName"
            label="Last name"
            outlined
            @change="save"
          />
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs8>
      <v-card>
        <v-card-title>
          Preferences
        </v-card-title>
        <v-flex
          class="subtitle-2"
          px-4
          mt-4
        >
          Notification Preferences
        </v-flex>
        <v-simple-table>
          <thead>
            <tr>
              <th>Topic</th>
              <th
                class="text-center"
                width="90"
              >
                Push
              </th>
              <th
                class="text-center"
                width="90"
              >
                Email
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="topic in topics"
              :key="topic.id"
            >
              <td>
                <div class="">
                  {{ topic.text }}
                </div>
                <div class="caption grey--text">
                  {{ topic.subtext }}
                </div>
              </td>
              <td>
                <v-layout
                  justify-center
                  ma-0
                >
                  <v-checkbox
                    v-model="pushPreferences.topics[topic.id]"
                    @change="save"
                  />
                </v-layout>
              </td>
              <td>
                <v-layout
                  justify-center
                  ma-0
                >
                  <v-checkbox
                    v-model="emailPreferences.topics[topic.id]"
                    @change="save"
                  />
                </v-layout>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-flex
          class="subtitle-2"
          xs12
          px-4
          mt-4
        >
          Notification Emails
        </v-flex>
        <v-list>
          <template v-for="(token, tokenId) in emailPreferences.tokens">
            <v-list-item
              :key="tokenId"
              @click="()=>{}"
            >
              <v-list-item-avatar>
                <v-icon>email</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ token.email }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  text
                  icon
                  small
                  color="grey"
                  @click="removeEmailToken(tokenId)"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <!-- <v-divider></v-divider> -->
          </template>
        </v-list>
        <!-- <v-divider></v-divider>
        <v-simple-table>
          <tbody>
            <tr v-for="(token, tokenId) in emailPreferences.tokens" :key="tokenId">
              <td>
                <v-icon left>email</v-icon>
                {{token.email}}
              </td>
              <td width="10">
                <v-btn text icon small color="grey" @click="removeEmailToken(tokenId)">
                  <v-icon>close</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table> -->
        <v-flex pa-4>
          <v-layout
            ma-0
            align-center
          >
            <v-spacer />

            <v-dialog
              v-model="dialog"
              max-width="500px"
            >
              <template #activator="{ on }">
                <v-btn
                  color="primary"
                  small
                  text
                  v-on="on"
                >
                  <v-icon left>
                    add
                  </v-icon>add
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  New Notification Email
                </v-card-title>
                <v-card-text>
                  <SiInputText
                    v-model="newEmail"
                    label="Email"
                    outlined
                    :rules="[_ruleEmail()]"
                    hide-details
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    color="grey"
                    @click="dialog = false"
                  >
                    cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="createNewEmailToken"
                  >
                    Create
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-flex>
        <!-- <v-flex class="subtitle-2" pa-4>
          Push token

        </v-flex>
        <v-flex px-4 pb-4 class="caption">
          {{_pushToken}}
        </v-flex> -->
      </v-card>
    </v-flex>
  </si-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'
import validations from '@/mixins/validations'

export default {
  mixins: [ helpers, binder, validations ],
  props: {

  },
  data () {
    return {
      dialog: false,
      newEmail: '',
      topics: [
        { id: 'assistance', text: 'Assistance Requests', subtext: 'Notification when a new assistance request is submitted' },
        { id: 'contact', text: 'Contact Requests', subtext: 'Notification when a new contact request is submitted' },
        { id: 'sysadmin', text: 'System Admin', subtext: 'Critical system alerts such as errors' }
      ],
      user: {
        details: {},
        preferences: {
          push: { topics: {}, tokens: {} },
          email: { topics: {}, tokens: {} }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['_user', '_pushToken']),
    userId () {
      return this.$route.params.sub || this._user.uid
    },
    pushPreferences: {
      get () {
        if (!(this.user.preferences || {}).push) this.$set(this.user.preferences, 'push', { topics: {}, tokens: {} })
        return (this.user.preferences || {}).push || { topics: {}, tokens: {} }
      },
      set (v) {
        this.$set(this.user.preferences, 'push', v)
      }
    },
    emailPreferences: {
      get () {
        if (!(this.user.preferences || {}).email) this.$set(this.user.preferences, 'email', { topics: {}, tokens: {} })
        return (this.user.preferences || {}).email
      },
      set (v) {
        this.$set(this.user.preferences, 'email', v)
      }
    }
  },
  beforeMount () {
    this.$store.commit('set_appBarTitle', { title: 'User Profile', icon: 'account_circle' })
    const callback = (v) => {
      this.user = { ...this.user, ...v}
    }
    this.$bindRtdb('user',`users/console/${this.userId}`, { callback, loader: true } )
    // this.$bindxxx(rtdb.ref(`users/console/${this.userId}`), (user) => {
    //   this.user = { ...this.user, ...user}
    // }, true)
  },
  methods: {
    save () {
      rtdb.ref(`users/console/${this.userId}`).set(this.user)
    },
    createNewEmailToken () {
      let id = btoa(this.newEmail)
      let token = {
        email: this.newEmail,
        name: `${this.user.details.firstName} ${this.user.details.lastName}`,
        active: true
      }
      rtdb.ref(`users/console/${this.userId}/preferences/email/tokens/${id}`).set(token)
      this.newEmail = ''
      this.dialog = false
    },
    removeEmailToken (id) {
      rtdb.ref(`users/console/${this.userId}/preferences/email/tokens/${id}`).remove()
    }
  }
}
</script>

<style lang="css" scoped>

</style>
